var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgBuild = function SvgBuild(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#323232",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "m13.5 13.7-6.8 6.8c-.9.9-2.3.9-3.2 0-.9-.9-.9-2.3 0-3.2l6.8-6.8c-.8-2-.3-4.3 1.3-5.9 1.7-1.7 4.2-2 6.2-1.2.1 0 .1.1 0 .2l-3.6 3.6 1.3 1.3 1.3 1.3 3.7-3.6h.2c1 2 .5 4.5-1.2 6.2-1.7 1.6-4 2-6 1.3Z"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgBuild);
export default ForwardRef;